__turbopack_context__.v({
  "list": "EntitySampleDisplay-module__MP3Bnq__list",
  "paragraph": "EntitySampleDisplay-module__MP3Bnq__paragraph",
});
